import { Col, Form, Input, Modal, notification, Row } from 'antd';
import { localize } from 'mixins/helpers';
import React, { FC, useState } from 'react';
import { resetPassword } from '../actions';
import { ChangePasswordByEdsDto } from '../block-auth.type';
import Button from '/react4xp/mixins/ui/button/button';

const ResetPassAuthModal: FC<any> = (props: any) => {
    const [form] = Form.useForm();

    const [isLoading, setIsLoading] = useState(false);

    const changePassword = () => {
        setIsLoading(true);

        const data: ChangePasswordByEdsDto = {
            newPassword: form.getFieldValue('newPassword'),
            oldPassword: props.oldPassword,
            signedData: props.signedData,
        };

        // апи для смены пароля
        resetPassword(data)
            .then(() => {
                props.close();
                form.resetFields();
                notification['success']({
                    message: 'Пароль успешно изменен!',
                    description: 'Для авторизации используйте новый пароль',
                });
            })
            .finally(() => setIsLoading(true));
    };

    return (
        <Modal
            open={props.open}
            onCancel={props.close}
            footer={
                <Row
                    justify="end"
                    gutter={15}
                    className="pt-3"
                >
                    <Col>
                        <Button
                            type="primary"
                            color="gold"
                            onClick={changePassword}
                            loading={isLoading}
                        >
                            {localize('button.send', props.translations)}
                        </Button>
                    </Col>
                    <Col>
                        <Button onClick={props.close}>
                            {localize('button.close', props.translations)}
                        </Button>
                    </Col>
                </Row>
            }
        >
            <div className="my-3">
                <h5>{localize('Смена пароля', props.translations)}</h5>

                <Form
                    form={form}
                    layout="vertical"
                >
                    <Form.Item
                        label={localize('block-auth-new-password', props.translations)}
                        name="newPassword"
                        rules={[
                            {
                                required: true,
                                message: localize('block-auth-required-field', props.translations),
                            },
                            {
                                pattern:
                                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                message: localize(
                                    'block-auth-incorrect-password-format',
                                    props.translations
                                ),
                            },
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>
                    <Form.Item
                        label={localize('block-auth-repeat-password', props.translations)}
                        name="repeatPassword"
                        rules={[
                            {
                                required: true,
                                message: localize('block-auth-required-field', props.translations),
                            },
                            {
                                pattern:
                                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                message: localize(
                                    'block-auth-incorrect-password-format',
                                    props.translations
                                ),
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('newPassword') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(
                                        new Error(
                                            localize('password-not-equal', props.translations)
                                        )
                                    );
                                },
                            }),
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default ResetPassAuthModal;
